import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {ActivityI} from "../../../../infrastructure/interfaces/task.interface";
import {InfoTokenService, TranslateService} from "@mangosoft/mango-layout";

@Component({
  selector: 'app-services-woocommerce',
  templateUrl: './services-woocommerce.component.html',
  styleUrls: ['./services-woocommerce.component.scss']
})
export class ServicesWoocommerceComponent  implements OnDestroy, OnInit{
  @Input() activityData: ActivityI | null = null;
  @Output() onOutputData: EventEmitter<any> = new EventEmitter<any>();

  destroy$ = new Subject<void>();

  language: string = "es";
  token!: string;

  config!: any;

  constructor(
    private translateService: TranslateService,
    private authService: InfoTokenService
  ) {
  }

  ngOnInit() {
    this.token = this.authService.getToken();

    if (this.activityData?.api){
      this.config = {
        sku: this.activityData?.metadata?.sku || '',
        data: this.activityData?.metadata?.data || {},
        woo_credentials: this.activityData?.metadata?.woo_credentials || {client_key: '', client_secret: ''},
        woo_s3_url: this.activityData?.metadata?.woo_s3_url || '',
        woo_cloudfront_url: this.activityData?.metadata?.woo_cloudfront_url || '',
        woo_api: this.activityData?.metadata?.woo_api || '',
        api: this.activityData?.api || '',
        token: this.token,
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSync($event: any){
    this.onOutputData.emit($event.detail || {});
  }
}
